module.exports = __webpack_public_path__ + "media/img/apple-icon-144x144-5f2a840ff6830a0e3b465b724e62d6f7.png";